import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AppPlatform, UpdateAppVersionPolicy } from "../../../admin-api/apps";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

export function useAppVersionPolicies() {
	return useQuery({
		queryFn: () => adminApi.apps.list(),
		queryKey: queryKeys.appVersions.all,
	});
}

export function useUpdateAppVersionPolicy() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ platform, body }: { platform: AppPlatform; body: UpdateAppVersionPolicy }) =>
			adminApi.apps.update(platform, body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.appVersions.all });
		},
	});
}
